<template>
  <section v-loading="subLoading">
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <TableBox ref="tableBox"/>
    <SubBtnBox
        :customPosifix="false"
        :cancelTextName="'返回'"
        @sub="submit">
    </SubBtnBox>

  </section>
</template>

<script>
import TableBox from './tableBox';
import SubBtnBox from 'components/subBtnBox';
import {getDepartmentAllList} from 'api';
import {savePathVehicleBinding} from 'api/operate';
export default {
  components: {
    TableBox,
    SubBtnBox,
  },
  data () {
    return {
      subLoading: false,
      selectResult: [],
      searchBoxData: {
        orgIdOptions: [], // 所属部门
        form: [
          {
            label: '路径名称',
            value: 'pathName',
            type: 'show',
            default: this.$route.query.pathName ? decodeURIComponent(this.$route.query.pathName) : '',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          {
            label: '所属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择所属部门',
          },
          {
            label: '是否在路径中',
            value: 'isInPath',
            type: 'checkbox',
            options: [
              {label: '是', value: 1},
              {label: '否', value: 0},
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      const id = this.$route.query.id;
      if (id) {
        searchBoxData.id = id;
      }
      if (searchBoxData.isInPath) {
        searchBoxData.isInPath = searchBoxData.isInPath.length > 1 ? '' : searchBoxData.isInPath[0];
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    async submit () {
      let arr = [];
      let selectResult = this.$refs.tableBox.tableData.selectResult;
      if (selectResult.length > 0) {
        selectResult.map((item) => {
          arr.push({
            plateNumber: item.plateNumber,
          });
        });
      }
      this.subLoading = true;
      const res = await savePathVehicleBinding({
        pathVehicleBindingInfo: JSON.stringify(arr),
        id: this.$route.query.id,
      });
      if (!res.failed) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.subLoading = false;
        this.close();
      } else {
        this.subLoading = false;
      }
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
